import React, { FC, Fragment, useState } from "react";
import { Box, Link, Stack } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";
import { MenuItems } from "./HeaderMenuLinks";
import { COLORS } from "../../theme";

export const MobileHeaderMenu: FC<{ title: string; menuItems?: MenuItems }> = ({ title, menuItems }) => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    return (
        <Fragment>
            <Stack sx={{ backgroundColor: menuOpen ? COLORS.BACKGROUND_SHADED : COLORS.BACKGROUND }}>
                <Link
                    underline={"none"}
                    onClick={() => setMenuOpen(!menuOpen)}
                    color={COLORS.SB_GREY}
                    sx={{ my: 2, px: 1 }}
                >
                    <Box>{title}</Box>
                    <Box sx={{ flexGrow: 1 }} />
                    <Box>
                        <KeyboardArrowDown />
                    </Box>
                </Link>
                {menuOpen &&
                    menuItems?.map((linkItem) => (
                        <Link
                            key={linkItem.label}
                            href={linkItem.href}
                            target={"_blank"}
                            underline={"none"}
                            color={COLORS.SB_GREY}
                            sx={{ my: 2, px: 1 }}
                        >
                            {linkItem.label}
                        </Link>
                    ))}
            </Stack>
        </Fragment>
    );
};
